import { ACTION } from './constants';

const initialState = {
    modalParameters: {},
    showModal: false,
    modalName: '',
    showHeader: true,
    fundDetails:{
        apiLoaded: false,
    },
    allSchemeDetails:{
      apiLoaded: false,
    },
    kycVerificationData:{
        apiLoaded: false,
    },
    eCartTrendingFundData:{
        apiLoaded: false,
    },
    sendOtpEcart:{
        apiLoaded: false,
    },
    resendOtpEcart:{
        apiLoaded: false,
    },
    savePreloginEcart:{
        apiLoaded: false,
    },
    updatePreloginEcart:{
      apiLoaded: false,
    },
    filterList:{
      apiLoaded: false
    }
};

export default function eCartReducer(state = initialState, action) {
    switch (action.type) {   
        case ACTION.GET_FUND_DETAILS :
          return {...state , fundDetails: {data:action.data, apiLoaded: true}};
        case ACTION.GET_ALL_SCHEME_DETAILS :
          return{...state,allSchemeDetails: {data:action.data, apiLoaded: true}};
        case ACTION.GET_TRENDING_FUND_JAVA :
          return{...state,eCartTrendingFundData: {...action.data, apiLoaded: true}};
        case ACTION.VERIFY_ECART_KYC :
            console.log('verify KYc data' + action.data);
          return {...state, kycVerificationData:{...action.data, apiLoaded: true}};
        // case ACTION.GET_TRENDING_FUND_DATA :
        //         return{...state, trendingFundData:{...action.data, apiLoaded: true}};
        case ACTION.SEND_OTP_ECART :
                return{...state, sendOtpEcart:{...action.data, apiLoaded: true}};
        case ACTION.RESEND_OTP_ECART :
                return{...state, resendOtpEcart:{...action.data, apiLoaded: true}};
        case ACTION.SAVE_PRELOGIN_ECART :
                return{...state, savePreloginEcart:{...action.data, apiLoaded: true}};
        case ACTION.UPDATE_ECART_FOLIO_ECART :
                return{...state, updatePreloginEcart:{...action.data, apiLoaded: true}};
        case ACTION.SAVE_KYC_DATA :
                return {...state, saveKycData:{...action.data, apiLoaded: true}};   
        case ACTION.GET_FILTER_LIST : 
                return {...state, filterList:{data: action.data, apiLoaded: true}}     
        default:
            return state;
    }
}
